<app-color-list-preview [colorList]="overviewListColorSet" [maximumCreelPositionsToShow]="8"> </app-color-list-preview>
